import { getTemplateNavHeaderStyles } from '../NavHeader-Level2/NavHeader-Level2.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="navheader-utility">
  <slot></slot>
</div>
`
class NavHeaderLevel2Utility extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('NavHeaderUtility connectedCallback: ', this)
  }
}

customElements.define('ts-navheader-level2-utility', NavHeaderLevel2Utility)
